import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

@Injectable()
export class ProfileActions {

  static UPDATE = 'Profile.Update';

  constructor( private _store: Store<IAppState>){

  }

  public Update(profile: IUserProfile): any {
    return this._store.dispatch({
      type:  ProfileActions.UPDATE,
      payload: profile
    });
  }

}
